import { upperFirst } from 'lodash/fp';

import { DisplayValueWrapper, Label, PlaceholderText } from './styles';

export type DisplayValueProps = {
  getValue: () => string;
  hasValue: boolean;
  label: string;
  showFieldsRequiredLabel?: boolean;
};

const DisplayValue = ({ label, getValue, hasValue, showFieldsRequiredLabel }: DisplayValueProps) => {
  const asterisk = showFieldsRequiredLabel ? '*' : '';
  const value = getValue();

  return (
    <DisplayValueWrapper>
      <Label>
        {upperFirst(label)}
        {asterisk}
      </Label>
      <PlaceholderText $hasValue={hasValue} aria-label={value} title={value}>
        {value}
      </PlaceholderText>
    </DisplayValueWrapper>
  );
};

export default DisplayValue;
